import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get, isEmpty, toNumber } from "lodash";
import { showError } from "../../../../../../utils/utilities";
import { useParams } from "react-router-dom";
import { Col, Row } from "antd";
import Button from "../../../../../../components/functional_components/Button/PFButton";
import { DownloadOutlined } from "@ant-design/icons";
import "./CashFlow.css";
import { VictoryArea, VictoryChart, VictoryGroup, VictoryAxis, VictoryLabel } from "victory";
import html2canvas from "html2canvas";
import { setLoading } from "../../../../../../redux/ducks/Loading";
import ProjectDashboard from "../../../../../../services/api/ProjectDashboard";
import Legend from "./Legend";
import dayjs from "dayjs";

const Progress = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const params = useParams();
  const [state, setState] = useState({
    dataChart: {},
    numberOfMonth: [],
    month: [],
    loading: false,
    lines: [],
  });

  const STYLE = {
    invoicingBCU: { stroke: "#89C0E4", strokeWidth: 1, fillOpacity: 0, strokeDasharray: "4,3" },
    invoicingEAC: { stroke: "#89C0E4", strokeWidth: 1, fillOpacity: 0 },
    invoicingActual: { fill: "#89C0E4", stroke: "#89C0E4", strokeWidth: 0, fillOpacity: 0.5 },
    cashInBCU: { stroke: "#243F78", strokeWidth: 1, fillOpacity: 0, strokeDasharray: "4,3" },
    cashInEAC: { stroke: "#243F78", strokeWidth: 1, fillOpacity: 0 },
    cashInActual: { fill: "#243F78", stroke: "#243F78", strokeWidth: 0, fillOpacity: 0.5 },
    costsBCU: { stroke: "#C1C9D1", strokeWidth: 1, fillOpacity: 0, strokeDasharray: "4,3" },
    costsEAC: { stroke: "#C1C9D1", strokeWidth: 1, fillOpacity: 0 },
    revenueBCU: { stroke: "#7C8B9E", strokeWidth: 1, fillOpacity: 0, strokeDasharray: "4,3" },
    revenueEAC: { stroke: "#7C8B9E", strokeWidth: 1, fillOpacity: 0 },
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    dispatch(setLoading(true));
    const data = await ProjectDashboard.getDataCashFlow(params.id);
    if (!data.error) {
      buildStructure(data);
      let line = [];
      Object.entries(data).forEach((item) => {
        if (!isEmpty(item[1])) {
          line.push(item[0]);
        }
      });
      setState((prevState) => ({
        ...prevState,
        dataChart: data,
        lines: line,
      }));
    } else {
      showError(get(data, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  const buildStructure = (data) => {
    const formatMonth = (val) => {
      if (toNumber(val) < 10) {
        return `0${val}`;
      }
      return val;
    };

    const numberOfMonth = [];
    let singleMonth = "";
    const month = [];
    let adjustYear = data.startYear;
    let resetMonth = data.startMonth;
    for (let i = 1; i <= data.nmonth; i++) {
      numberOfMonth.push(i); // buildArray numberOfMonth es [1,2,3,4,....]
    }
    numberOfMonth.forEach(() => {
      if (resetMonth > 12) {
        resetMonth = 1;
        adjustYear += 1;
      }
      singleMonth = `${formatMonth(resetMonth)}/${dayjs(adjustYear.toString(), "YYYY").format("YY")}`;
      resetMonth++;
      month.push(singleMonth); // buildArray numberOfMonth es ["11/21", "12/21", "01/22", "02/22" ....]
    });
    setState((prevState) => ({
      ...prevState,
      numberOfMonth,
      month,
    }));
  };

  const downloadDiv = async () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    const input = document.getElementById("CashFlow");
    return html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("img/png");
      let link = document.createElement("a");
      link.download = "CashFlow.png";
      link.href = imgData;
      link.click();
      setState((prevState) => ({ ...prevState, loading: false }));
    });
  };

  return (
    <>
      <Row type="flex" justify="end" className="mb-10">
        <Button
          isLoading={state.loading}
          currentIcon={<DownloadOutlined className="icon-medium" />}
          clickCallback={downloadDiv}
        />
      </Row>

      {!isEmpty(state.dataChart) && (
        <div id="CashFlow">
          <Legend />
          <Row type="flex" align="middle">
            <Col offset={2} span={22}>
              <VictoryChart>
                <VictoryAxis
                  style={{
                    tickLabels: {
                      fontSize: 6,
                    },
                  }}
                  tickLabelComponent={<VictoryLabel angle={-45} />}
                  // tickValues specifies both the number of ticks and where
                  // they are placed on the axis
                  tickValues={state.numberOfMonth}
                  tickFormat={state.month}
                  offsetY={50}
                />
                <VictoryAxis
                  style={{
                    tickLabels: {
                      fontSize: 6,
                    },
                  }}
                  dependentAxis
                  // tickFormat specifies how ticks should be displayed
                  tickFormat={(x) => `${x.toLocaleString(currentLanguage === "GB" ? "en-GB" : "it-IT")} €`}
                />
                <VictoryGroup>
                  {state.lines.map((item) => {
                    return (
                      <VictoryArea
                        key={item}
                        style={{ data: STYLE[item] }}
                        data={get(state.dataChart, item, "")}
                        x="quarter"
                        y="earnings"
                      />
                    );
                  })}
                </VictoryGroup>
              </VictoryChart>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default Progress;
